import Marionette from "backbone.marionette";
import Moment from "moment";
import ListsTpl from "views/lists/listsView.ejs";
import LineTpl from "views/lists/formLine.ejs";

import PaginationView from "views/pagination/pagination.js";

import SearchModel from "models/searchModel.js";
import ParametersModel from "models/parametersModel.js";
import FiltersModel from "models/filtersModel.js";
var parametersModel = new ParametersModel();

import CSS from "views/lists/lists.css";

import S from "session/session.js";
import T from "session/token.js";

var bootbox = require('bootbox');

export default Marionette.LayoutView.extend({
    initialize: function(data) {

        $('.content-wrapper').css({ 'margin-left': '230px' });
        this.areaId = data.areaId;
        this.model = new SearchModel();
        this.listenTo(this.collection, "sync", this.applyView.bind(this));
        this.listenTo(S.mApp, "next", this.next.bind(this));
        this.listenTo(S.mApp, "prev", this.prev.bind(this));
        this.listenTo(S.mApp, "page", this.page.bind(this));
        var filtersModel = new FiltersModel();
        filtersModel.fetch({
            data: {
                page: "goods",
            },
            beforeSend: T.useToken,
            success: function() {
                // Pre filters
                this.filters = filtersModel.toJSON();
            }.bind(this)
        });
    },
    filter: 0,
    areaId: null,
    template: ListsTpl,
    render: function() {
        $("#loaderContainer").show();

        parametersModel.fetch({
            data: {
                instanceId: S.instanceId,
            },
            beforeSend: T.useToken,
            success: function() {
                this.collection.fetch({
                    data: {
                        page: 1,
                        instanceId: S.instanceId,
                        areaId: this.areaId
                    },
                    beforeSend: T.useToken,
                    success: function() {
                        $("#loaderContainer").hide();
                        this.$el.html(this.template({
                            attributes: this.collection.attributes,
                            params: parametersModel.toJSON(),
                            lang: _.extend(this.collection.lang, S.userInfo.attributes.lang),
                            areas: S.areas,
                            rolex: S.userInfo.get("role")
                        }));
                    }.bind(this)
                });
            }.bind(this)
        });
    },
    applyView: function() {




        if (_.isEmpty(this.filters)) {
            $("#lines").html(""); // Empty filters container                      
            $("#lines").append(LineTpl({ params: parametersModel.toJSON(), filters: "", lang: this.collection.lang, areas: S.areas, showremove: false }));
        } else {
            $("#lines").html(""); // Empty filters container
            var showit = false;
            for (var f in this.filters) {
                $("#lines").append(LineTpl({ params: parametersModel.toJSON(), filters: this.filters[f], lang: this.collection.lang, areas: S.areas, showremove: showit }));
                showit = true;
            }
        }



        var textCurrenArea = this.areaId;
        /////var textCurrenArea = this.areaId.split('_')[0];

        var data = [];
        /* var buttonAvailable = '<span class="btn btn-sm btn-info glyphicon glyphicon-pencil" id="edit"></span>&nbsp;' +
        '<span class="btn btn-sm btn-danger glyphicon glyphicon-remove removeGood" id="remove"></span>&nbsp;'; */

        var buttonAvailable = '<span class="ion ion-ios-compose text-light-blue" id="edit"></span>&nbsp;' +
            '<span class="ion ion-ios-close text-red removeGood" id="remove"></span>&nbsp;';

        if (S.userInfo.get("role") == 2 && textCurrenArea == 'bajas') {
            buttonAvailable = ' &nbsp;' +
                '<span class="ion ion-ios-close text-red removeGood" id="remove"></span>&nbsp;';
        }


        _.each(this.collection.models, function(model) {
            var lang = this.collection.lang;
            var areaFuncional;

            if (model.get("value") && S.userInfo.get("role") === "3" || model.get("value") && S.userInfo.get("role") === "2") {
                switch (model.get("value")) {
                    case "3":
                        if (textCurrenArea == 'bajas') {
                            buttonAvailable = '<span class="ion ion-ios-eye text-light-blue" id="watch"></span>&nbsp;';
                        } else {
                            buttonAvailable = '<span class="ion ion-ios-compose text-light-blue" id="edit"></span>&nbsp;' +
                                '<span class="ion ion-ios-close text-red removeGood" id="remove"></span>&nbsp;';

                        }

                        break;
                    case "2":
                        if (textCurrenArea == 'bajas') {
                            buttonAvailable = '<span class="ion ion-ios-eye text-light-blue" id="watch"></span>&nbsp;';
                        } else {
                            buttonAvailable = '<span class="ion ion-ios-compose text-light-blue" id="edit"></span>&nbsp;';
                        }
                        break;
                    case "1":
                        buttonAvailable = '<span class="ion ion-ios-eye text-light-blue" id="watch"></span>&nbsp;';
                        break;
                }
            }


            data.push({
                id: model.attributes.id,
                itemId: model.attributes.itemId,
                denominacion: model.attributes.denominacion,
                name: lang[model.attributes.entity],
                epigraph: lang[model.attributes.epigraph],
                areaFuncional: S.userInfo.attributes.lang[model.attributes.areaFuncional],
                /*juridicos_uso: lang[model.attributes.juridicos_uso],*/
                juridicos_costeAdquisicion: this.formatNumber(model.attributes.descriptivos_importe, "€"),
                fechaAlta: this.checkDate(model.attributes.fechaAlta),
                action: '<div class="unbreakable">' + buttonAvailable +
                    '<span class="ion ion-ios-paper text-yellow openPDF"></span>&nbsp;' +
                    '<input type="hidden" name="idimp" id="idimp_' + model.attributes.id + '" value="' + model.attributes.itemId + '"></div>'
            });
        }.bind(this));

        $("#listsData").bootstrapTable({
            striped: true,
            uniqueId: 'id',
            columns: [{
                field: 'itemId',
                title: 'Id',
                sortable: true
            }, {
                field: 'denominacion',
                title: this.collection.lang.DENOMINACION,
                sortable: true
            }, {
                field: 'name',
                title: this.collection.lang.ENTIDAD,
                sortable: true
            }, {
                field: 'epigraph',
                title: this.collection.lang.EPIGRAFE,
                sortable: true
            }, {
                field: 'areaFuncional',
                title: this.collection.lang.A_FUNCIONAL,
                sortable: true
                    /*  }, {
                          field: 'juridicos_uso',
                          title: this.collection.lang.USO,
                          sortable: true
                          */
            }, {
                field: 'juridicos_costeAdquisicion',
                title: this.collection.lang.ECONOMICOS_VALORTOTAL,
                sortable: true,
                class: 'text-right'
            }, {
                field: 'fechaAlta',
                title: this.collection.lang.FECHA_ALTA,
                sortable: true
            }, {
                field: 'action',
                title: '',
            }]
        });

        $("#listsData").bootstrapTable("removeAll");
        $("#listsData").bootstrapTable("append", data);

        this.pagination.show(new PaginationView({
            attributes: this.collection.pageAttributes
        }));

        //Date controls
        $(".dateGroup").datetimepicker({
            format: 'DD/MM/YYYY'
        });

        // Remove active menu items
        $(".sidebar li").removeClass("active");
        $(".sidebar li > ul").removeClass("active menu-open");
        // Add active menu items        
        if (this.areaId !== undefined) {
            var currentArea = this.areaId.split('_')[0];
            switch (currentArea) {
                case "bajas":
                    $("[id^=BAJAS_]").parent().addClass("active");
                    break;
                case "option":
                    $("#list-title").html(this.collection.lang.A_FUNC);
                    var subArea = this.areaId.toUpperCase();
                    $("#" + subArea).parents("ul").addClass("active menu-open");
                    $("#" + subArea).parents("li").addClass("active");
                    break;
                default:
                    // EPIGRAPHS
                    $("#list-title").html(this.collection.lang.EPIGRAFES);
                    var subEpigraph = this.areaId.toUpperCase();
                    $("#" + subEpigraph).parents("ul").addClass("active menu-open");
                    $("#" + subEpigraph).parents("li").addClass("active");
            }
        } else {
            $("#LISTS").parents("li").addClass("active");
            $("#LISTS").parents("li").find("ul").addClass("active menu-open");
            $("[id^=BIENES_]").parent().addClass("active");
        }

        // Don't aplly on firstload
        // this.adjustForm();
    },
    events: {
        "click .searchButton.add": "addLine",
        "click .searchButton.remove": "removeLine",
        "click #edit": "edit",
        "click .removeGood": "removeGood",
        "click #watch": "watch",
        "click .openPDF": "pdf",
        "submit #searchForm": "submit",
        "click #nuevo": "nuevo",
        "change #fieldname": "adjustForm",
        "click #exportXLS": "exportXLS",
        "click #exportPDF": "exportPDF",
        "click #exportPDF_all": "exportPDF_all",
        "sort.bs.table #listsData": "orderData",
        "click #removeFilter": "removeFilter"
    },
    params: {},
    orderData: function(ev, $param1, $param2) {
        ev.preventDefault();
        var page = parseInt($(".pagination li.active").attr("id").split("-")[1]);
        this.params = {
            column: $param1,
            order: $param2
        };

        this.searchService(page, this.params);
    },
    addLine: function(ev) {
        var operator = $(ev.target).parents(".formLine").find("#operator");

        if (operator.val() === "--")
            operator.val("and");

        $("#lines").append(LineTpl({
            filters: "",
            params: parametersModel.toJSON(),
            lang: this.collection.lang,
            areas: S.areas,
            showremove: true
        }));

        //Date controls
        $(".dateGroup").datetimepicker({
            format: 'DD/MM/YYYY'
        });

        this.adjustForm();
    },
    removeLine: function(ev) {
        $(ev.target).parents(".formLine").remove();
    },
    adjustForm: function() {
        $(".formLine").each(function() {
            var selector = $(this).find("#fieldname");
            /* $(this).find("#operatorHolder select").hide();
            $(this).find("#valueHolder > *").hide(); */
            $(this).find("#operatorHolder select").addClass("hidden");
            $(this).find("#valueHolder > *").addClass("hidden");

            switch (selector.val()) {
                case "itemId":
                    $(this).find("#nbcomparador").removeClass("hidden");
                    $(this).find("#numberValue").removeClass("hidden");
                    break;
                case "denominacion":
                    /* $(this).find("#nbIncluye").show();
                    $(this).find("#textValue").show();*/
                    $(this).find("#nbIncluye").removeClass("hidden");
                    $(this).find("#textValue").removeClass("hidden");
                    break;
                case "epigraph":
                    $(this).find("#nbIgual").removeClass("hidden");
                    $(this).find("#epigraphValue").removeClass("hidden");
                    break;
                case "areaFuncional":
                    $(this).find("#nbIgual").removeClass("hidden");
                    $(this).find("#areaValue").removeClass("hidden");
                    break;
                case "juridicos_uso":
                    $(this).find("#nbIgual").removeClass("hidden");
                    $(this).find("#usoValue").removeClass("hidden");
                    break;
                case "juridicos_situacionPatrimonial":
                    $(this).find("#nbIgual").removeClass("hidden");
                    $(this).find("#situacionValue").removeClass("hidden");
                    break;
                case "juridicos_naturaleza":
                    $(this).find("#nbIgual").removeClass("hidden");
                    $(this).find("#naturalezaValue").removeClass("hidden");
                    break;
                case "juridicos_costeAdquisicion":
                    $(this).find("#nbcomparador").removeClass("hidden");
                    $(this).find("#numberValue").removeClass("hidden");
                    break;
                case "fechaAlta":
                    $(this).find("#nbcomparador").removeClass("hidden");
                    $(this).find("#dtpickerBuscar").removeClass("hidden");
                    break;
                case "juridicos_fechaAdquisicion":
                    $(this).find("#nbcomparador").removeClass("hidden");
                    $(this).find("#dtpickerBuscar").removeClass("hidden");
                    break;
                case "descriptivos_direccion":
                    $(this).find("#nbIncluye").removeClass("hidden");
                    $(this).find("#textValue").removeClass("hidden");
                    break;
                case "catastrales_referencia":
                    $(this).find("#nbIncluye").removeClass("hidden");
                    $(this).find("#textValue").removeClass("hidden");
                    break;
                case "registrales_finca":
                    $(this).find("#nbIncluye").removeClass("hidden");
                    $(this).find("#textValue").removeClass("hidden");
                    break;
                case "entity":
                    $(this).find("#nbIgual").removeClass("hidden");
                    $(this).find("#entidadValue").removeClass("hidden");
                    break;
                case "descriptivos_ubicacion":
                    $(this).find("#nbIncluye").removeClass("hidden");
                    $(this).find("#textValue").removeClass("hidden");
                    break;
                case "descriptivos_importe":
                    $(this).find("#nbcomparador").removeClass("hidden");
                    $(this).find("#numberValue").removeClass("hidden");
                    break;
                default:
                    $(this).find("#nbIgual").removeClass("hidden");
                    $(this).find("#textValue").removeClass("hidden");

            }
        });
    },
    submit: function(ev) {
        this.filter = 1;
        ev.preventDefault();
        var request = {};
        var data = [];
        var newFilters = [];
        $.each($(".formLine"), function() {
            var line = {};
            line.fieldname = $(this).find("#fieldname").val();
            line.nbcomparador = $(this).find(".operator:visible").val();
            line.value = $(this).find(".value:visible").val();
            line.operator = $(this).find("#operator").val();
            line.operator === "--" ? "" : line.operator;
            line.nbfield = $(this).find(".operator:visible").attr("id");
            line.valuefield = $(this).find(".value:visible").attr("id");
            if (line.fieldname) {
                data.push(line);
                newFilters.push(line);
            }
        });

        this.filters = newFilters;
        request.instanceId = S.instanceId;
        request.data = data;
        request.page = 1;
        request.areaId = this.areaId;

        this.model.save(request, {
            beforeSend: T.useToken,
            success: function() {
                this.collection.set(this.model.attributes._embedded);
                //Update page attributes as well
                this.collection.pageAttributes = {
                    page: this.model.attributes.page,
                    page_count: this.model.attributes.page_count,
                    page_size: this.model.attributes.page_size,
                    total_items: this.model.attributes.total_items
                };
                this.applyView();
            }.bind(this)
        });
    },
    exportXLS: function(ev) {
        $("#loaderContainer").show();
        ev.preventDefault();
        var request = {};
        var data = [];
        var newFilters = [];
        $.each($(".formLine"), function() {
            var line = {};
            line.fieldname = $(this).find("#fieldname").val();
            line.nbcomparador = $(this).find(".operator:visible").val();
            line.value = $(this).find(".value:visible").val();
            line.operator = $(this).find("#operator").val();
            line.operator === "--" ? "" : line.operator;
            line.nbfield = $(this).find(".operator:visible").attr("id");
            line.valuefield = $(this).find(".value:visible").attr("id");
            if (line.fieldname) {
                data.push(line);
                newFilters.push(line);
            }
        });

        this.filters = newFilters;
        request.instanceId = S.instanceId;
        request.areaId = this.areaId;
        request.lang = this.collection.lang;
        request.data = data;

        var xhr = new XMLHttpRequest();
        xhr.open('POST', 'api/export/exportListXLS.php', true);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.setRequestHeader('Authorization', 'Bearer ' + S.token);
        xhr.responseType = 'arraybuffer';
        xhr.onload = function(e) {
            if (this.status == 200) {
                var blob = new Blob([this.response]);
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = "list_" + Moment().format('DD-MM-YYYY_h-mm-ss') + ".csv";
                link.click();
                $("#loaderContainer").hide();
            }
        };
        xhr.send(JSON.stringify(request));
    },
    exportPDF: function() {
        var goods = [];
        $("table#listsData tbody tr").each(function() {
            goods.unshift(parseInt($(this).attr("data-uniqueid")));
            ///goods.push(parseInt($(this).attr("data-uniqueid")));
        });

        S.mApp.trigger("navigate", {
            to: "pdfView",
            goods: goods,
            lang: this.collection.lang
        });
    },
    edit: function(ev) {
        var good_id = $(ev.target).parents("tr").attr("data-uniqueid");
        S.mApp.trigger("navigate", {
            to: "goodDetail",
            good_id: good_id,
            lang: this.collection.lang,
            isEditable: 1
        });
    },
    removeGood: function(ev) {

        if (ev) {
            ev.preventDefault();
            var thisAlias = this;

            $(ev.currentTarget).confirmation({
                rootSelector: ".removeGood",
                placement: 'left',
                singleton: true,
                title: S.userInfo.attributes.lang.DELETE_CONFIRM,
                popout: true,
                onConfirm: function() {
                    var good_id = $(ev.target).parents("tr").attr("data-uniqueid");
                    var currentModel = thisAlias.collection.get(good_id);
                    var page = parseInt($(".pagination li.active").attr("id").split("-")[1]);
                    currentModel.destroy({
                        beforeSend: T.useToken,
                        data: {
                            instanceId: S.instanceId
                        },
                        processData: true,
                        success: function() {
                            thisAlias.searchService(page, thisAlias.params);
                        }.bind(thisAlias)
                    });

                },
                btnOkClass: 'btn-sm btn-danger',
                btnOkLabel: S.userInfo.attributes.lang.ACCEPT,
                btnCancelClass: 'btn-sm btn-default',
                btnCancelLabel: S.userInfo.attributes.lang.CANCEL,

            });
            $(ev.currentTarget).confirmation('show');
        }
    },
    watch: function(ev) {
        var good_id = $(ev.target).parents("tr").attr("data-uniqueid");
        S.mApp.trigger("navigate", {
            to: "goodDetail",
            good_id: good_id,
            view: true,
            lang: this.collection.lang,
            isEditable: 0
        });
    },
    nuevo: function(ev) {
        S.mApp.trigger("navigate", {
            to: "goodDetail",
            lang: this.collection.lang
        });
    },
    pdf: function(ev) {


        ev.preventDefault();
        var secretario;
        var thisAlias = this;
        /////ALL ROLS
        if (S.userInfo.attributes.role < 4) {


            var good_id = $(ev.target).parents("tr").attr("data-uniqueid");
            var id = $('#idimp_' + good_id).val();



            $(ev.currentTarget).confirmation({
                rootSelector: ".openPDF",
                placement: 'left',
                singleton: true,
                title: S.userInfo.attributes.lang.PDF_SECRETARY,
                popout: true,
                onConfirm: function() {
                    $("#loaderContainer").show();
                    S.mApp.trigger("navigate", {
                        to: "pdfView",
                        goods: [good_id],
                        goodsID: [id],
                        lang: thisAlias.collection.lang,
                        secretario: true
                    });
                },
                onCancel: function() {
                    $("#loaderContainer").show();
                    S.mApp.trigger("navigate", {
                        to: "pdfView",
                        goods: [good_id],
                        goodsID: [id],
                        lang: thisAlias.collection.lang,
                        secretario: false
                    });
                },
                btnOkClass: 'btn-sm btn-success',
                btnOkLabel: S.userInfo.attributes.lang.YES,
                btnCancelClass: 'btn-sm btn-primary',
                btnCancelLabel: S.userInfo.attributes.lang.NO,

            });
            $(ev.currentTarget).confirmation('show');
        }

    },
    searchService: function(page, params, resetFilters) {

        $("#loaderContainer").show();

        // FIXME: Arreglo rápido, no repetir código de submit cuando hay filtro ¿?¿?
        if (!this.filter) {
            var data = {};
            var searchItems = $(".search");

            $.each(searchItems, function() {
                if ($(this).val())
                    data[$(this).attr("name")] = $(this).val();
            });

            data.page = page || 1;
            data.instanceId = S.instanceId;

            if (params && params.column) {
                data.column = params.column;
                data.order = params.order;
            }

            data.areaId = this.areaId;
            data.resetFilters = resetFilters;

            this.collection.fetch({
                data: data,
                beforeSend: T.useToken,
                instanceId: S.instanceId,
            }).always(function() {
                $("#loaderContainer").hide();
            });
        } else {
            var request = {};
            var data = [];
            var newFilters = [];
            $.each($(".formLine"), function() {
                var line = {};
                line.fieldname = $(this).find("#fieldname").val();
                line.nbcomparador = $(this).find(".operator:visible").val();
                line.value = $(this).find(".value:visible").val();
                line.operator = $(this).find("#operator").val();
                line.operator === "--" ? "" : line.operator;
                line.nbfield = $(this).find(".operator:visible").attr("id");
                line.valuefield = $(this).find(".value:visible").attr("id");
                if (line.fieldname) {
                    data.push(line);
                    newFilters.push(line);
                }
            });

            this.filters = newFilters;
            request.instanceId = S.instanceId;
            request.data = data;
            request.page = page || 1;
            request.areaId = this.areaId;
            request.resetFilters = resetFilters;

            this.model.save(request, {
                beforeSend: T.useToken,
                success: function() {
                    this.collection.set(this.model.attributes._embedded);
                    //Update page attributes as well
                    this.collection.pageAttributes = {
                        page: this.model.attributes.page,
                        page_count: this.model.attributes.page_count,
                        page_size: this.model.attributes.page_size,
                        total_items: this.model.attributes.total_items
                    };
                    this.applyView();
                    $("#loaderContainer").hide();
                }.bind(this)
            });
        }
    },
    removeFilter: function() {
        this.filter = 0;
        // Reset filters
        this.filters = "";
        $("#lines").html(""); // Empty filters container              
        this.searchService(1, this.params, true);
    },
    formatNumber: function(n, symbol) {
        var format = require('format-number');
        var myFormat = format({ prefix: '', suffix: ' ' + symbol, integerSeparator: '.', decimal: ',' });
        var formattedNumber = myFormat(n, { noSeparator: false });
        return formattedNumber;
    },
    checkDate: function(date) {
        if (date === "00/00/0000") {
            return "-";
        } else {
            return date;
        }
    },
    next: function(ev) {
        var nextPage = parseInt($(".pagination li.active").attr("id").split("-")[1]) + 1;
        this.searchService(nextPage, this.params);
    },
    prev: function(ev) {
        var prevPage = parseInt($(".pagination li.active").attr("id").split("-")[1]) - 1;
        this.searchService(prevPage, this.params);
    },
    page: function(ev) {
        var page = parseInt($(ev.target).parent().attr("id").split("-")[1]);
        this.searchService(page, this.params);
    },
    regions: {
        pagination: "#paginationHolder"
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/views/lists/listsView.js
// module id = 188
// module chunks = 0